var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.538,
    height: 25,
    viewBox: "0 0 43.538 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.521,25H4.4A4.406,4.406,0,0,1,0,20.6V4.4A4.406,4.406,0,0,1,4.4,0h24.12a4.406,4.406,0,0,1,4.4,4.4V7.814l5.6-5.6a2.939,2.939,0,0,1,5.018,2.078V20.707a2.939,2.939,0,0,1-5.018,2.078l-5.6-5.6V20.6A4.406,4.406,0,0,1,28.521,25ZM12.349,2.5a2.011,2.011,0,0,0-2.009,2v16a2.011,2.011,0,0,0,2.009,2,1.975,1.975,0,0,0,1.192-.4l10.667-8a2,2,0,0,0,0-3.2l-10.667-8A1.974,1.974,0,0,0,12.349,2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCamera);
export default __webpack_public_path__ + "static/media/my-camera.5c02feb877cd05b6ed7f67fbd3bf22a9.svg";
export { ForwardRef as ReactComponent };